import React, { useState } from 'react';
import { HardDrive, Download, Loader2, CheckCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const AdminBackup = () => {
  const [downloading, setDownloading] = useState(false);
  const [done, setDone] = useState(false);

  const startBackup = async () => {
    setDownloading(true);
    setDone(false);
    try {
      const link = document.createElement('a');
      link.href = `${API}/admin/backup`;
      link.click();
      setTimeout(() => { setDownloading(false); setDone(true); }, 3000);
    } catch (e) {
      setDownloading(false);
    }
  };

  return (
    <div dir="rtl" data-testid="admin-backup-section">
      <h2 className="text-xl font-black text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
        <HardDrive className="w-5 h-5 inline ml-2" />גיבוי האתר
      </h2>

      <div className="bg-white rounded-xl p-6 border border-stone-200 max-w-lg">
        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-[#D97706]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <HardDrive className="w-10 h-10 text-[#D97706]" />
          </div>
          <h3 className="font-bold text-lg text-stone-800 mb-1">גיבוי מלא</h3>
          <p className="text-sm text-stone-500">הורדת כל קבצי האתר, קוד, תמונות, מסד נתונים והגדרות</p>
        </div>

        {/* Stats */}
        <div className="bg-[#D97706]/5 border border-[#D97706]/20 rounded-xl p-4 mb-4 text-sm font-bold text-center">
          <span className="text-2xl text-[#D97706]">149</span>
          <span className="text-stone-600 mr-2">קבצים</span>
          <span className="text-stone-400 mx-2">|</span>
          <span className="text-2xl text-[#D97706]">~1.5</span>
          <span className="text-stone-600 mr-2">MB</span>
        </div>

        <div className="bg-stone-50 rounded-xl p-4 mb-4 text-sm text-stone-600 space-y-1.5">
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> קוד שרת (Backend)</span><span className="text-stone-400 text-xs">server.py, .env, tests</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> קוד אתר (Frontend)</span><span className="text-stone-400 text-xs">109 קבצים</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> UI Components (Shadcn)</span><span className="text-stone-400 text-xs">46 רכיבי עיצוב</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> תמונות וסרטונים</span><span className="text-stone-400 text-xs">url_mapping.json (66 לינקים)</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> מסד נתונים</span><span className="text-stone-400 text-xs">10 טבלאות (הזמנות, מוצרים, קופונים...)</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> חיבורים חיצוניים</span><span className="text-stone-400 text-xs">CardCom, UPS, HFD, Facebook, Bit</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> מיפוי כתובות מדיה</span><span className="text-stone-400 text-xs">url_mapping.json</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> קונפיגורציה</span><span className="text-stone-400 text-xs">tailwind, postcss, plugins, hooks</span></p>
          <p className="flex items-center justify-between"><span className="flex items-center gap-2"><CheckCircle className="w-4 h-4 text-green-500" /> בדיקות ודוחות</span><span className="text-stone-400 text-xs">test_reports, pytest</span></p>
        </div>

        <button
          onClick={startBackup}
          disabled={downloading}
          className={`w-full py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2 transition-colors ${
            downloading ? 'bg-stone-300 text-stone-500' : done ? 'bg-green-600 hover:bg-green-700 text-white' : 'bg-[#D97706] hover:bg-[#B45309] text-white'
          }`}
          data-testid="backup-download-btn"
        >
          {downloading ? (
            <><Loader2 className="w-4 h-4 animate-spin" /> מכין גיבוי...</>
          ) : done ? (
            <><CheckCircle className="w-4 h-4" /> הגיבוי הורד בהצלחה!</>
          ) : (
            <><Download className="w-4 h-4" /> הורד גיבוי מלא</>
          )}
        </button>
      </div>
    </div>
  );
};

export default AdminBackup;
